import { Controller } from '@hotwired/stimulus';

// Theme toggle controller.
// Detects OS preference, reads cookie override, persists user choice.
//
// Usage:
//   <div data-controller="theme">
//     <button data-action="click->theme#toggle" data-theme-target="button">
//       <span data-theme-target="icon"></span>
//     </button>
//   </div>
export default class extends Controller {
  static targets = ['icon', 'button'];

  connect() {
    this.applyTheme();
    // Listen for OS theme changes (only if no manual override)
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.boundMediaChange = () => {
      if (!this.getSavedTheme()) this.applyTheme();
    };
    this.mediaQuery.addEventListener('change', this.boundMediaChange);
  }

  disconnect() {
    if (this.mediaQuery && this.boundMediaChange) {
      this.mediaQuery.removeEventListener('change', this.boundMediaChange);
    }
  }

  toggle() {
    const current = document.documentElement.getAttribute('data-bs-theme');
    const next = current === 'dark' ? 'light' : 'dark';
    this.setTheme(next);
    this.saveTheme(next);
  }

  // Private

  applyTheme() {
    const saved = this.getSavedTheme();
    const system = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    const theme = saved || system;
    this.setTheme(theme);
  }

  setTheme(theme) {
    document.documentElement.setAttribute('data-bs-theme', theme);
    this.updateIcon(theme);
  }

  updateIcon(theme) {
    if (this.hasIconTarget) {
      this.iconTarget.textContent = theme === 'dark' ? '\u2600\uFE0F' : '\uD83C\uDF19';
    }
  }

  getSavedTheme() {
    const match = document.cookie.match(/(?:^|; )theme=(\w+)/);
    return match ? match[1] : null;
  }

  saveTheme(theme) {
    document.cookie = `theme=${theme};path=/;max-age=31536000;SameSite=Lax`;
  }
}
